import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { QueryParamsService } from 'src/app/shared/utils/query-params.service';
import { NavLanguage } from 'src/app/shared/utils/language.constants';
import { LANGUAGE_TOGGLES } from '../global-filters.constants';
import { GlobalFiltersService } from '../global-filters.service';

/**
 * EN / DE toggles in the nav bar. Additional languages picked in the filters
 * pop-up ride along in `lang` untouched.
 */
@Component({
  selector: 'app-language-toggle',
  templateUrl: './language-toggle.component.html',
  styleUrls: ['./language-toggle.component.scss'],
})
export class LanguageToggleComponent implements OnInit, OnDestroy {
  readonly options = LANGUAGE_TOGGLES;
  active: NavLanguage[] = [];

  private lang?: string;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private globalFilters: GlobalFiltersService,
    private queryParamsService: QueryParamsService,
  ) {}

  ngOnInit(): void {
    this.queryParamsService.queryParams$
      .pipe(
        map((params) => params?.lang as string | undefined),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe((lang) => {
        this.lang = lang;
        this.active = this.globalFilters.navLanguages(lang);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onValuesChange(values: string[]): void {
    this.globalFilters.setNavLanguages(this.lang, values as NavLanguage[]);
  }
}
